export const CREATE_INVALIDATION_RULE = 'create';
export const CONDITIONS_FIELD = 'conditions';
